module.exports = __webpack_public_path__ + "static/media/sanguo-1.43ce22ce.png";